import type { JointSettingsSlice, JointSettingsState, ViewerSliceCreator } from "./types";

export const jointSettingsInitialState: JointSettingsState = {
  jointSettingsExpanded: {},
};

export const createJointSettingsSlice: ViewerSliceCreator<JointSettingsSlice> = (set) => ({
  ...jointSettingsInitialState,

  toggleJointSettingsExpanded: (jointName) =>
    set((state) => {
      if (state.jointSettingsExpanded[jointName]) {
        delete state.jointSettingsExpanded[jointName];
      } else {
        state.jointSettingsExpanded[jointName] = true;
      }
    }),
});
